export const formatDuration = (ms) => {
  ms = 1000 * Math.round(ms / 1000);
  var d = new Date(ms);
  var min = Math.floor(ms / (1000 * 60));
  return min === 0 ? `${d.getUTCSeconds()}s` : `${min}m ${d.getUTCSeconds()}s`;
};
